import { useTranslation } from 'react-i18next';
import { Spinner } from '@ntconsult/aluma-react';

export function LoadingScreen() {
  const { t } = useTranslation('common');

  return (
    <div className="flex items-center justify-center min-h-[100dvh] bg-surface-raised">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="lg" />
        <p className="text-foreground-muted">{t('loading')}</p>
      </div>
    </div>
  );
}
